export function isGroupMissing(value: any ,options: any) {
  return options?.availableGroups?.length ? {
    isGroupMissing: {
      message: "isGroupMissing"
    }
  } : null;
}
